import MovieCard from '@/components/base/MovieCard';
import SectionHeading from '@/components/base/SectionHeading';
import type { Movie } from '@/types/movie';

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  movies: Movie[];
  tinted?: boolean;
}

export default function MovieSection({ title, subtitle, moreTo, movies, tinted }: MovieSectionProps) {
  return (
    <section className={`w-full px-4 md:px-8 py-10 md:py-14 ${tinted ? 'bg-background-100/60' : ''}`}>
      <SectionHeading title={title} subtitle={subtitle} moreTo={moreTo} />
      <div
        data-product-shop
        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5"
      >
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}